module.exports = __webpack_public_path__ + "static/media/salad.1a712b0d.svg";